// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0403488b","644":"98aaa8aa"}[chunkId] + ".chunk.js";
};